"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settlementSlice = settlementSlice;
const appConstants_1 = require("../../constants/appConstants");
const dateUtils_1 = require("../../utils/dateUtils");
const date = new Date();
const currentYear = date.getFullYear();
const settlementInitialState = {
    settlement: {
        settlements: [],
        filters: {
            parentCard: 'allSourceCards',
            virtualCard: 'allVirtualCards',
            month: String(appConstants_1.months?.[date.getMonth()]?.value),
            year: String(currentYear),
            showTransactionWithoutReceipts: false,
        },
        areSettlementFiltersManuallySet: false,
        options: {
            parentCards: [],
            virtualCards: [],
            months: [],
            years: [],
        },
        page: 1,
        isReceiptUploadRemove: false,
    },
};
function settlementSlice(set) {
    return {
        ...settlementInitialState,
        setSettlements(settlements, sortBy = 'most-recent') {
            set((state) => {
                const sortedSettlements = [...settlements]?.sort((a, b) => (0, dateUtils_1.compareSettlementDates)(a, b, sortBy));
                state.settlement.settlements = sortedSettlements;
                return state;
            }, false, '[setSettlements]');
        },
        resetSettlementFilters() {
            set((state) => {
                state.settlement.filters.parentCard = settlementInitialState.settlement.filters.parentCard;
                state.settlement.filters.virtualCard = settlementInitialState.settlement.filters.virtualCard;
                state.settlement.filters.month = settlementInitialState.settlement.filters.month;
                state.settlement.filters.year = settlementInitialState.settlement.filters.year;
                state.settlement.filters.showTransactionWithoutReceipts =
                    settlementInitialState.settlement.filters.showTransactionWithoutReceipts;
                return state;
            }, false, '[resetSettlementFilters]');
        },
        setSettlementFilters(filters) {
            set((state) => {
                state.settlement.filters = filters;
                return state;
            }, false, '[setSettlementFilters]');
        },
        setSettlementOptions(options) {
            set((state) => {
                state.settlement.options = options;
                return state;
            }, false, '[setSettlementOptions]');
        },
        setPage(page) {
            set((state) => {
                state.settlement.page = page;
                return state;
            }, false, '[setPage]');
        },
        setAreSettlementFiltersManuallySet(areSettlementFiltersManuallySet) {
            set((state) => {
                state.settlement.areSettlementFiltersManuallySet = areSettlementFiltersManuallySet;
                return state;
            }, false, '[setAreSettlementFiltersManuallySet]');
        },
        setIsReceiptUploadRemove(isReceiptUploadRemove) {
            set((state) => {
                state.settlement.isReceiptUploadRemove = isReceiptUploadRemove;
                return state;
            }, false, '[setIsReceiptUploadRemove]');
        },
    };
}
